module.exports = __webpack_public_path__ + "static/media/3.d71b5fb6.png";